import { LOGIN, GET_AVATAR, OPEN_CLOSE_SIDEBAR, UPLOAD_FILE, RESET, UPDATE_KYC, SET_CUSTOMIZATION_ID, SET_MOBILE, SET_LANGUAGES } from './constants';

export function setUser(payload) {
	return { type: LOGIN, payload };
}

export function updateAvatar(payload) {
	return { type: GET_AVATAR, payload: payload };
}

export function openCloseSidebar(payload) {
	return { type: OPEN_CLOSE_SIDEBAR, payload: payload };
}

export function uploadFile(payload) {
	return { type: UPLOAD_FILE, payload: payload };
}

export function resetState() {
	return { type: RESET };
}

export function updateKyc(payload) {
	return { type: UPDATE_KYC, payload: payload };
}

export function setCustomizationId(payload) {
	return { type: SET_CUSTOMIZATION_ID, payload: payload };
}

export const setMobile = (payload) => ({ type: SET_MOBILE, payload });

/**
* Set available languages
* @param {*} payload Languages Object
* @return {*} callback to give to the dispatching component
*/
export const setLanguages = (payload) => ({
	type: SET_LANGUAGES, payload
});